import React, { useState } from "react";
import { Box, Typography, Button } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { userSelector } from "../user-redux/selector";
import { userLogout } from "../user-redux/action";
import Key from "../../clientVariables.json";

const JnpRedirect = () => {
  const dispatch = useDispatch();
  const { user } = useSelector(userSelector);

  const handleLogin = () => {
    window.location.href = Key.url;
  };

  const handleLogout = () => {
    dispatch(
      userLogout({
        userid: user?.id,
      })
    );
    sessionStorage.clear();
    window.location.href = Key.url;
  };
  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          margin: "200px auto",
        }}
      >
        <Box
          padding={3}
          sx={{ boxShadow: "0 0 5px grey", width: "600px" }}
          //  margin="auto"
        >
          <Typography variant="h5" gutterBottom sx={{ color: "#406882" }}>
            Benchsales user Access
          </Typography>
          <Typography variant="body1" gutterBottom>
            {user && Object.keys(user).length !== 0
              ? "💼 You’re logged in. Welcome back! Ready to accomplish more today? 🚀"
              : "🔒 Please log in to access your account and continue your work. 🔑"}
          </Typography>
          <Box marginTop={2}>
            {user && Object.keys(user).length === 0 ? (
              <Button variant="contained" color="primary" onClick={handleLogin}>
                Login
              </Button>
            ) : (
              <Button
                variant="contained"
                color="primary"
                onClick={handleLogout}
              >
                Logout
              </Button>
            )}
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default JnpRedirect;
